module.exports = __webpack_public_path__ + "8df42fb5ed75d1baa885c85a280da65f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/winter-chalet.png
// module id = 2882
// module chunks = 0